import axios from 'axios';

export default async function getAgentHistoryRequest() {
    try {
        return await axios.post(`/rest/user/get-agent-history`)
    } catch (error) {
        throw error;
    }
}